import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import publisher from '@/api/publisher'
import help from '@/utils/help'
import { settingCountry } from '@/api/setting'
export default {
  data() {
    return {
      params: {},
      rules: {},
      colors: ['#1E1D40', '#512DA8', '#5D4037', '#4CAF50', '#00BCD4'],
      personalColor: '',
      countryList: {},
      urlAddress: '' // 复制文件地址
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      domain: 'getDomain',
      user: 'getUser'
    })
  },
  mounted() {
    this.getRules()
    this.getPubilsher()
    this.countrySearch()
  },
  methods: {
    async handleUpload(key, files) {
      const file = files[0]
      const imgFiles = ['logo']
      const pdfFiles = ['conditionsTerms', 'useTerms']
      const imgTypes = ['image/jpeg', 'image/png']
      const pdfTypes = ['application/pdf']
      let rightType = true
      if (imgFiles.includes(key)) {
        rightType = imgTypes.includes(file.type)
      } else if (pdfFiles.includes(key)) {
        rightType = pdfTypes.includes(file.type)
      }
      if (!rightType) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(
        file,
        `${this.publisherId}/file`,
        file.name
      )

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params, key, url)
      this.$set(this.params, key + 'Name', file.name)
    },

    delFile(key) {
      this.params[key] = ''
      this.params[key + 'Name'] = ''
    },

    goToPage(val, name) {
      help.download(val, name)
    },

    async submit() {
      const flag = this.$refs['basic-information-form'].validate()
      if (this.params.reviewLimitDay <= 0) {
        this.$message.error({
          title: 'Error',
          content: 'The day can not be less 0!'
        })
        return
      }
      if (flag) {
        await publisher.edit(this.params.id, this.params)
        this.$message.success({
          title: 'Success',
          content: 'This Publisher has been saved!'
        })
        this.getPubilsher()
      }
    },
    preview() {},
    async getPubilsher() {
      this.params = await publisher.get()
      if (!this.colors.includes(this.params.mainColor)) {
        this.personalColor = this.params.mainColor
      }
    },
    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },
    getRules() {
      this.rules = {
        logo: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].publisherLogo +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        fullName: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].publisherFullName +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        name: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].publisherAbbreviation +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        email: [
          {
            required: true,
            message: 'Email' + this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].inputCorrectEmail
          }
        ],
        mainColor: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].themeColor +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        downloadNum: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].downloadNum +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        articleNum: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].articleNum +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        readNum: [
          {
            required: true,
            message:
              this.LANGUAGE[this.language].readNum +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        reviewLimitDay: [
          {
            min: 0,
            max: 999,
            message: 'The day can not more than three digits!'
          }
        ],
        copyright: [
          {
            max: 64,
            message: 'Copyright must be less than 64 digits!'
          }
        ]
      }
    },
    handleCopyAddress(val) {
      this.urlAddress = this.domain + '/' + val
      help.copyToBlock(this.urlAddress)
      this.$message.success({
        title: 'Success',
        content: 'The File Address has been copied to the clipboard!'
      })
    }
  }
}
